<template>
  <section
    class="categorise-content h-full"
    :class="{ 'flex-col': isShowCorrectAnswer }"
  >
    <section v-if="!isShowCorrectAnswer" class="options-section">
      <div>
        <span>
          {{ $i18nPresenter.t('Options') }}
        </span>
        <span class="total-options">{{ options.length }}</span>
      </div>
      <section class="options">
        <div
          v-for="(option, index) in options"
          :key="index"
          class="option"
        >
          {{ option.value }}
        </div>
      </section>
    </section>
    <section class="category-section" :class="layoutClass">
      <div
        v-for="(category, index) in categories"
        :key="category.id"
        class="category"
        :style="{
          borderColor: categoryColorMap[index],
          backgroundColor: categoryBackgroundColorMap[index],
        }"
        @click="selectedCategory = category"
      >
        <div
          class="title"
          :style="{
            backgroundColor: categoryColorMap[index],
          }"
        >
          <span class="left-block">
            <span
              class="category-annotation"
              :style="{
                color: categoryAnnotationColorMap[index],
              }"
            >{{ categoryAnnotationMap[index] }}</span>
            <!-- Todo: Break into component -->
            <span class="category-name" v-if="category.value">{{ category.value }}</span>
            <span class="opacity-50" v-else>
              {{ `${$i18nPresenter.t('Category')} ${categoryAnnotationMap[index]}` }}
            </span>
          </span>
          <span v-if="isShowCorrectAnswer && category.options && category.options.length">
            ({{ category.options.length }})
          </span>
        </div>
        <div
          class="options"
        >
          <div
            v-for="(option, id) in category.options"
            :key="id"
            class="option"
          >
            {{ option.value }}
          </div>
        </div>
      </div>
    </section>
    <section class="answer-result" v-if="isShowCorrectAnswer">
      <Answer
        :numberOfCorrectAnswers="correctedAnswerPerSlide"
        :numberOfIncorrectAnswers="incorrectedAnswerPerSlide"
      ></Answer>
    </section>
    <CategoriseModal
      v-if="selectedCategory && selectedCategory.options.length > 0"
      @hide="selectedCategory = null"
      :category="selectedCategory"
    />
  </section>
</template>

<script>
import CategoriseModal from './CategoriesModal.vue'
import Answer from '@/components-v2/presentation-editor/middle/common/Answer.vue'

const twoRowLayoutApplyRules = [5, 6, 7, 8]
const twoColumnLayoutApplyRules = [2]
const threeColumnLayoutApplyRules = [3, 5, 6]
const fourColumnLayoutApplyRules = [4, 7, 8]

export default {
  name: 'CategoriseContentView',
  components: {
    CategoriseModal,
    Answer,
  },
  props: {
    categories: {
      type: Array,
      required: true,
      default: () => [],
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    correctedAnswerPerSlide: {
      type: Number,
      default: 0,
    },
    incorrectedAnswerPerSlide: {
      type: Number,
      default: 0,
    },
    isShowCorrectAnswer: {
      type: Boolean,
      default: false,
    },
    categoryColorMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryBackgroundColorMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryAnnotationMap: {
      type: Array,
      required: true,
      default: () => [],
    },
    categoryAnnotationColorMap: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  data() {
    return {
      selectedCategory: null,
    }
  },
  computed: {
    layoutClass() {
      let rowClass = 'one-row'
      let columnClass = ''
      const categoryCount = this.categories.length
      if (twoRowLayoutApplyRules.includes(categoryCount)) {
        rowClass = 'two-row'
      }

      if (twoColumnLayoutApplyRules.includes(categoryCount)) {
        columnClass = 'two-column'
      }

      if (threeColumnLayoutApplyRules.includes(categoryCount)) {
        columnClass = 'three-column'
      }

      if (fourColumnLayoutApplyRules.includes(categoryCount)) {
        columnClass = 'four-column'
      }

      if (this.isShowCorrectAnswer) return `${rowClass} show-answer-category-layout ${columnClass}`
      return `${rowClass} ${columnClass}`
    },
  },
}

</script>

  <style lang="scss" scoped>
  .categorise-content {
    display: flex;
    gap: 0.75rem;
    padding: 18px;
    max-height: 100%;

    & > .options-section {
      width: 270px;
      min-width: 270px;
      background-color: #F0F4FA;
      border: 1px solid #D3D7E1;
      border-radius: 8px;

      & > div {
        font-weight: 700;
        font-size: 20px;
        color: #525F7F;
        display: flex;
        align-items: center;
        justify-content: center;
        padding-block: 20px;
        gap: 0.75rem;

        & > .total-options {
            color: #282E3E;
            font-size: 1rem;
            background-color: white;
            padding: 0.5rem;
            line-height: 1;
            display: inline-flex;
            align-items: center;
            justify-content: center;
        }
      }

      & > .options {
        max-height: calc(100% - 84px);
      }
    }

    & > .category-section {
        flex: 1;
        display: grid;
        gap: 0.75rem;
        grid-template-columns: repeat(2, 1fr);

        &.show-answer-category-layout {
          max-height: calc(100% - 52px);
        }

        & > .category {
            border: 2px solid;
            border-radius: 8px;
            & > .title {
                cursor: pointer;
                font-size: 20px;
                color: white;
                font-weight: 700;
                display: flex;
                justify-content: space-between;
                align-items: center;
                gap: 0.75rem;
                padding: 0.75rem;
                height: 72px;

                & .left-block {
                  display: flex;
                  gap: 0.75rem;
                }

                & .category-annotation {
                    font-size: 20px;
                    width: 28px;
                    height: 28px;
                    background-color: white;
                    padding: 4px;
                    border-radius: 4px;
                    display: inline-flex;
                    align-items: center;
                    align-self: center;
                    justify-content: center;
                }

                & .category-name {
                  line-height: 24px;
                }
            }

            & > .options {
                max-height: calc(100% - 72px);
                padding: 0.75rem;
            }
        }
    }

    & > .answer-result {
      align-self: center;
    }

    .options {
        padding: 0 0.75rem 0.75rem 0.75rem;
        overflow-y: auto;
        display: flex;
        flex-direction: column;
        gap: 0.5rem;

        & > .option {
            font-size: 18px;
            color: #282E3E;
            padding: 0.75rem;
            background-color: white;
            border: 1px solid #D3D7E1;
            border-radius: 8px;
        }
      }
    .one-row {
        grid-template-rows: 100%;
    }

    .two-row {
        grid-template-rows: repeat(2, calc(50% - 0.75rem/2));
    }

    .two-column {
        grid-template-columns: repeat(2, 1fr);
    }

    .three-column {
        grid-template-columns: repeat(3, 1fr);
    }

    .four-column {
        grid-template-columns: repeat(4, 1fr);
    }
  }
  </style>
